import { TimelineMax, TweenMax } from 'gsap';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFVideoPlay } from '@/components/UI/svg/stories';
import Image from '@/components/UI/Image';

const StoryNewDay = ({ handleShowVideo }: { handleShowVideo: (url: string) => void }) => {
    const { useState, useEffect, isMobile, useLang } = useGlobal();
    const { t } = useLang('brandstory');
    const [showFirst, setShowFirst] = useState(false);
    const [showNext, setShowNext] = useState(false);
    let controller = null;
    const introducelist = [
        {
            imgurl: isMobile ? '/img/stories/h5/newday/day1.jpg' : '/img/stories/pc/newday/day1.jpg',
            videolink: 'https://www.youtube.com/embed/CArivHt8hu4',
            title: t('newday.lefttitle'),
            desc: t('newday.leftdesc'),
        },
        {
            imgurl: isMobile ? '/img/stories/h5/newday/day2.jpg' : '/img/stories/pc/newday/day2.jpg',
            videolink: 'https://www.youtube.com/embed/er-X6ybQb3s',
            title: t('newday.righttitle'),
            desc: t('newday.rightdesc'),
        },
    ];
    useEffect(() => {
        if (isMobile) return;
        controller = new window.ScrollMagic.Controller();

        const sceneA = new window.ScrollMagic.Scene({
            triggerElement: '.storyNewday', //触发元素
            offset: -500, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 500, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const timelineA1 = new TimelineMax();

        const tweenA1 = TweenMax.to(`.storyNewday .header`, 0.25, { opacity: 1 });
        const tweenA2 = TweenMax.to(`.storyNewday .screen-title`, 0.5, { y: 0 });
        const tweenA3 = TweenMax.to(`.storyNewday .screen-desc`, 0.5, { y: 0 });
        const tweenA4 = TweenMax.to(`.storyNewday .text .first`, 0.5, { y: 0 });
        const tweenA5 = TweenMax.to(`.storyNewday .text .next`, 0.5, { y: 0 });

        timelineA1.add(tweenA1).add(tweenA2, 0).add(tweenA3, 0).add(tweenA4, 0).add(tweenA5, 0);
        sceneA.setTween(timelineA1);

        const sceneB = new window.ScrollMagic.Scene({
            triggerElement: '.storyNewday', //触发元素
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 500, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const timelineB1 = new TimelineMax();
        const tweenB1 = TweenMax.to(`.storyNewday .header`, 0.3, { opacity: 0 });
        const tweenB2 = TweenMax.to(`.storyNewday .screen-title`, 0.6, { y: -200 });
        const tweenB3 = TweenMax.to(`.storyNewday .screen-desc`, 0.6, { y: -200 });
        const tweenB4 = TweenMax.to(`.storyNewday .text .first`, 0.6, { y: -175 });
        const tweenB5 = TweenMax.to(`.storyNewday .text .next`, 0.6, { y: -150 });
        const tweenB6 = TweenMax.to(`.storyNewday .nextscreen`, 0.5, { opacity: 1 });
        const tweenB7 = TweenMax.to(`.storyNewday .nextscreen .title`, 0.5, { y: 0 });
        const tweenB8 = TweenMax.to(`.storyNewday .nextscreen .desc`, 0.5, { y: 0 });

        timelineB1.add(tweenB1).add(tweenB2, 0).add(tweenB3, 0).add(tweenB4, 0).add(tweenB5, 0).add(tweenB6, 0.25).add(tweenB7, 0.25).add(tweenB8, 0.25);
        sceneB.setTween(timelineB1);

        controller.addScene(sceneA).addScene(sceneB);
    }, []);

    return (
        <div id="storyNewday" className={`${isMobile ? styled.story_mobile_newday : styled.story_newday} ${isMobile ? '' : 'content'} storyNewday`}>
            <div className="story_newday_sticky">
                <div className={`${showFirst ? 'show' : ''} header content`}>
                    <h5 className="screen-title">{t('menu.newday')}</h5>
                    <h5 className="screen-desc">{t('newday.title')}</h5>
                    <div className="text">
                        <p className="first">{t('newday.paraga')}</p>
                        <p className="next">{t('newday.paragb')}</p>
                    </div>
                </div>
                <div className={`${showNext ? 'show' : ''} nextscreen `}>
                    {introducelist.map((item, index) => (
                        <div className="introduce" key={index}>
                            <div className="img" onClick={() => handleShowVideo(item.videolink)}>
                                <Image src={item.imgurl} layout="fill" className="fullImgs" alt={item.title} aria-label={item.title} />
                                <EFVideoPlay className="videoplay" />
                            </div>
                            <h5 className="title">{item.title}</h5>
                            <p className="desc">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StoryNewDay;
